import React, { useState, useEffect, useMemo } from 'react';
import ProductDefaultImage from '../../../Assets/Products/productDefaultIMage.webp';

import DeleteIcon from '../../../Assets/Store/delete.svg';
import { removeCartItem } from '../../../redux/features/Cart/cartSlice';
import { PRODUCT_IMAGES_BASE_URL } from '../../../Constants/Config';
import { useSelector } from 'react-redux';
import Validation from '../../../Constants/Validation';

const SingleCartItem = ({
  cartItem,
  singleStore,
  cartData,
  merchantId,
  addingProduct,
  setAddingProduct,
}) => {
  const variantDataState = useSelector((state) => state.variant);
  const cartDataState = useSelector((state) => state.cart.cartData);
  const cartProductDetails = useSelector(
    (state) => state.cartProducts.cartProductDetails,
  );

  const isDisabled = useMemo(() => {
    return (
      (cartItem.product.quantity !== '0' &&
        cartItem.product.isstockcontinue === '0' &&
        cartItem.product.trackqnty === '1' &&
        cartItem.selectedQuantity >= +cartItem.product.quantity &&
        cartItem.product.isvarient !== '1') ??
      false
    );
  }, [cartItem]);

  const [disableQuantityUpdate, setdisableQuantityUpdate] =
    useState(isDisabled);

  const {
    // updateProductFromCart,
    handleImagesArray,
    filterCartData,
    handleDeleteCartProduct,
    handleUpdateCartItem,
  } = Validation();

  // fetching cart products
  const getCartProducts = () => {
    if (
      cartDataState &&
      variantDataState?.variantCartData.data &&
      cartProductDetails
    ) {
      const data = filterCartData(
        cartDataState,
        variantDataState?.variantCartData.data,
        cartProductDetails,
      );

      return data ? data : [];
    }
  };

  // handling product qty in the cart drawer, checking if qty is available to add and its add button is disabled
  useEffect(() => {
    if (disableQuantityUpdate) {
      // getting cart products
      const cartProducts = getCartProducts();

      // for variant product
      if (cartItem.varients.length > 0) {
        // storing all the variant products that are in cart, with complete info for each product
        const variantCartProductsInCart = [];
        variantDataState.variantCartData.data?.forEach((prod) => {
          cartProducts.forEach((cartProduct) => {
            if (
              prod.id === cartProduct.variantId &&
              prod.product_id === cartProduct.productId
            ) {
              variantCartProductsInCart.push(prod);
            }
          });
        });

        // from the Cart products getting current product info using the cartItem prop.
        const currentProduct = variantCartProductsInCart.find(
          (prod) =>
            prod?.id === cartItem.variantId &&
            prod?.product_id === cartItem?.productId,
        );

        const productId = currentProduct?.product_id;
        const productPurchaseQTY = +currentProduct?.purchase_qty;

        // getting same PQ products that are in Cart with complete info for each product..
        const samePQProducts = variantCartProductsInCart.filter(
          (prod) =>
            prod?.product_id === productId &&
            +prod?.purchase_qty === productPurchaseQTY,
        );

        const totalQty =
          samePQProducts && samePQProducts.length > 0
            ? samePQProducts.length
            : 0;

        // products max qty is more than 0 && this products total qty in cart is less than its max buying qty
        const lowerThanMaxQty =
          cartItem.maxQuantity > 0 && totalQty < cartItem.maxQuantity;

        // product is available infinitely.. stock continued
        const stockContinued = currentProduct.isstockcontinue === '1';

        // product has track qty - 1 & isstock continue - 0 but its not more than its max qty
        const limitedQtyButAvailable =
          currentProduct.isstockcontinue === '0' &&
          currentProduct.trackqnty === '1' &&
          totalQty < currentProduct.quantity;

        // user can buy more
        // 1) products stock is continued
        // 2) user has not yet reached maximum qty, its total qty is less than products max qty (available qty)
        // 3) track qty is 1 & stock continued is 0 but total qty is less than products actual qty
        const canBuyMore =
          stockContinued || lowerThanMaxQty || limitedQtyButAvailable;

        // conditions for allowing to add more qty-
        // 1) all cart products qty (totalQty) should be less than PQ limit
        // 2) current cart item quantity should be less than actual qty available (eg: a product has 5 qty and in cart its 2)
        if (totalQty < productPurchaseQTY && canBuyMore) {
          // disabling quantity increment button
          setdisableQuantityUpdate(false);
        }
      }
      // for non variant products
      else {
        const sameProducts = cartProducts.filter(
          (ele) => ele.cartProductId === cartItem.cartProductId,
        );
        const totalQty =
          sameProducts && sameProducts.length > 0 ? sameProducts.length : 0;

        // products max qty is more than 0 && this products total qty in cart is less than its max buying qty
        const lowerThanMaxQty =
          cartItem.maxQuantity > 0 && totalQty < cartItem.maxQuantity;

        // product is available infinitely.. stock continued
        const stockContinued = cartItem.product.isstockcontinue === '1';

        // product has track qty - 1 & isstock continue - 0 but its not more than its max qty
        const limitedQtyButAvailable =
          cartItem.product.isstockcontinue === '0' &&
          cartItem.product.trackqnty === '1' &&
          totalQty < cartItem.product.quantity;

        const canBuyMore =
          stockContinued || lowerThanMaxQty || limitedQtyButAvailable;

        // conditions for allowing to add more qty-
        // 1) all cart products qty (totalQty) should be less than its max qty
        if (canBuyMore) {
          // disabling quantity increment button
          setdisableQuantityUpdate(false);
        }
      }
    }
  }, [
    cartItem,
    cartDataState,
    disableQuantityUpdate,
    variantDataState?.variantCartData,
    cartProductDetails,
  ]);

  // useEffect(() => {
  //   console.log('cartItem: ', cartItem);
  // }, [cartItem]);

  const deleteCartProduct = (cartItem) => {
    // handleDeleteCartProduct ye function hai
    handleDeleteCartProduct(
      merchantId,
      variantDataState?.variantCartData.data,
      cartData,
      cartItem,
      disableQuantityUpdate,
      setdisableQuantityUpdate,
      removeCartItem,
    );
  };

  const imagesArray =
    cartItem &&
    cartItem.product &&
    cartItem.product.media &&
    handleImagesArray(cartItem.product.media);

  return (
    <>
      <div
        className={`quickvee-store-cart-single-item ${
          cartItem?.isOutOfStock ? 'error' : ''
        }`}
      >
        <div className="quickvee-scsi-image">
          <img
            onError={(e) => {
              e.target.src = ProductDefaultImage;
            }}
            src={
              cartItem && cartItem.product && cartItem.product.media
                ? `${PRODUCT_IMAGES_BASE_URL}upload/products/${
                    singleStore && singleStore.merchant_id
                  }/${imagesArray[0]}`
                : ProductDefaultImage
            }
            width={55}
            height="auto"
            alt="product"
          />
        </div>
        <div className="quickvee-scsi-content">
          <span className="q-cart-product-name">
            {cartItem.product &&
            cartItem.product.title &&
            cartItem.product.title.length > 25
              ? cartItem.product.title.slice(0, 25) + `...`
              : cartItem.product.title}{' '}
          </span>
          {cartItem &&
            cartItem.varients &&
            cartItem.varients.map((varient, index) => (
              <p key={index}>
                {' '}
                {varient.varientName} :<span> {varient.varientVl} </span>{' '}
              </p>
            ))}
          <div className="q-cart-product-amount-section">
            <div className="q-cart-product-amount-update">
              <button onClick={() => deleteCartProduct(cartItem)}>
                <i className="fa-solid fa-minus fa-lg"></i>
              </button>
              <span>{cartItem && cartItem.selectedQuantity}</span>
              <button
                disabled={disableQuantityUpdate || addingProduct}
                onClick={() => {
                  setAddingProduct(() => true);

                  // stopping user from adding products unless previous one resolves
                  if (addingProduct) {
                    return;
                  }

                  // this products total qty in cart + 1
                  const productTotalQty =
                    (cartData?.filter(
                      (ele) => ele.cartProductId === cartItem.cartProductId,
                    )?.length || 0) + 1;

                  handleUpdateCartItem(
                    cartItem,
                    productTotalQty,
                    'increment',
                    setdisableQuantityUpdate,
                    merchantId,
                    variantDataState?.variantCartData.data,
                    cartData,
                    setAddingProduct,
                  );
                }}
              >
                <i className="fa-solid fa-plus fa-lg"></i>
              </button>
            </div>
            <div className="q-cart-product-amount-calculation">
              <span>
                {cartItem &&
                !isNaN(cartItem.price) &&
                parseFloat(cartItem.price) >= 0
                  ? `$ ${parseFloat(cartItem.price).toFixed(2)}`
                  : ''}
              </span>
            </div>
          </div>
          <div className="q-cart-product-customize">
            <img
              src={DeleteIcon}
              width={32}
              alt="delete"
              onClick={() => deleteCartProduct(cartItem)}
            />
          </div>

          {(cartItem.bogoDiscountApplied ||
            cartItem.mixAndMatchDiscountApplied) && (
            <p
              className="no-stock-variant-product"
              style={{ color: '#00A86B' }}
            >
              Discount applied (-$
              {parseFloat(
                cartItem.bogoDiscountApplied
                  ? cartItem.bogoDiscount
                  : cartItem.mixAndMatchDiscount,
              ).toFixed(2)}
              )
            </p>
          )}

          {/* error will go here */}
          {cartItem?.pqLimitReached ? (
            <p className="no-stock-variant-product">
              Purchase Quantity Limit Reached!
            </p>
          ) : cartItem.isOutOfStock ? (
            <p className="no-stock-variant-product">Out of Stock!</p>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default SingleCartItem;
